import { Box, Typography } from "@mui/material";
import { FONT_DISPLAY } from "../../theme/v2Tokens";

interface ComingSoonProps {
  title: string;
}

export default function ComingSoon({ title }: ComingSoonProps) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      flex={1}
      gap={1}
    >
      <Typography
        variant="h4"
        sx={{ fontFamily: FONT_DISPLAY, fontWeight: 500 }}
      >
        {title}
      </Typography>
      <Typography
        variant="body1"
        sx={{ color: "var(--text-secondary)" }}
      >
        This page is being redesigned
      </Typography>
    </Box>
  );
}
